import React, { useContext, useMemo } from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  FaUserTie,
  FaFileContract,
  FaMoneyBillWave,
  FaCalendarCheck,
  FaUsersCog,
  FaChartBar,
  FaUserShield
} from "react-icons/fa";
import "../styles/sidebar.css";
import { AuthContext } from "../context/AuthContext";

const Sidebar = () => {
  const location = useLocation();
  const { role } = useContext(AuthContext);
  const roleUpper = (role || "").toUpperCase();

  const links = useMemo(() => {
    if (roleUpper === "PERSONNEL") {
      return [
        { path: "/personnel/dashboard", icon: <FaUserShield />, label: "Mon Espace" },
      ];
    }

    if (roleUpper === "ADMIN") {
      // ADMIN: pages d'administration étendues
      return [
        { path: "/personnel-admin", icon: <FaUserShield />, label: "Personnel" },
        { path: "/utilisateurs", icon: <FaUsersCog />, label: "Utilisateurs" },
        { path: "/corbeille", icon: <FaUsersCog />, label: "Corbeille" },
        { path: "/deverouiller-salaire", icon: <FaUsersCog />, label: "Déverrouiller salaire" },
        { path: "/parametrage", icon: <FaUsersCog />, label: "Paramétrage" },
      ];
    }

    if (roleUpper === "ASSISTANT") {
      // Assistant: uniquement Employés, Contrats, Salaires, Congés, CRG
      return [
        { path: "/employes", icon: <FaUserTie />, label: "Employés" },
        { path: "/contrats", icon: <FaFileContract />, label: "Contrats" },
        { path: "/salaires", icon: <FaMoneyBillWave />, label: "Salaires" },
        { path: "/conges", icon: <FaCalendarCheck />, label: "Congés" },
        { path: "/crg", icon: <FaUsersCog />, label: "Crg" },
      ];
    }

    // RH par défaut (pas d'accès Utilisateurs) + accès Paramétrage demandé
    return [
      { path: "/statistiques", icon: <FaChartBar />, label: "Statistiques" },
      { path: "/employes", icon: <FaUserTie />, label: "Employés" },
      { path: "/contrats", icon: <FaFileContract />, label: "Contrats" },
      { path: "/salaires", icon: <FaMoneyBillWave />, label: "Salaires" },
      { path: "/conges", icon: <FaCalendarCheck />, label: "Congés" },
      { path: "/crg", icon: <FaUsersCog />, label: "Crg" },
      { path: "/impressions", icon: <FaFileContract />, label: "Impressions" },
      { path: "/parametrage", icon: <FaUsersCog />, label: "Paramétrage" },
      { path: "/personnel-admin", icon: <FaUserShield />, label: "Personnel" },
    ];
  }, [roleUpper]);

  return (
    <div className="sidebar">
      <h2 className="sidebar-title"> RH AGUIPEX</h2>
      <Nav className="flex-column">
        {links.map((item) => (
          <Link
            to={item.path}
            key={item.path}
            className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
          >
            {item.icon}
            <span className="link-label">{item.label}</span>
          </Link>
        ))}
      </Nav>
    </div>
  );
};

export default Sidebar;
